import { Component, OnInit } from '@angular/core';
import { SearchServicesComponent } from './dummy/search-services.component';
import { ListAssignServicesComponent } from './dummy/list-assign-services.component';
import { ServicesService } from "../../../injections/services.service";
import * as moment from 'moment';
import {Router, ActivatedRoute} from "@angular/router";

@Component({
  templateUrl: '../templates/main-assign.html'
})
export class MainAssignComponent implements OnInit{

    public services: any = [];
    public filter: string = null;
    public filterAssigned:any = null;
    public cleanFilter: boolean = false;
    public showModal: boolean = false;
    public commentsResume: object = {
      commentData: [],
      serviceData: []
    };
    public search = null;
    constructor(
      private servicesService: ServicesService, 
      private _router: Router
    ){}

    public setFilterPipe(event){
      this.filter = event;
    }

    public setFilterAssigned(event){
      this.filterAssigned = event;
    }

    public searchServices(filters: object) {
      this.emptyFilters();
      this.search = filters;
      this.services = [];
      this.servicesService.searchServices(filters)
      .subscribe(data => {
        this.services.push(data);
      });

    }

    public manageSendToApp(event: any) {
        if(event["type"] == "send") this.sendToApp(event["id"]);
        else if(event["type"] == "remove") this.removeFromApp(event["id"]);
        else if(event["type"] == "sendWithPro") this.sendToAppWithPro(event["id"], event["idPro"]);
    }

    public getAssignServices() {
      this.servicesService.getAssignServices()
        .subscribe(data => {
          this.services = data;
      });
    }
    
    public emptyFilters(){
      this.filter = null;
      this.filterAssigned = null;
      this.cleanFilter = !this.cleanFilter;
    }

    public showModalComments(event: any) {
        this.getResumeComments(event);
    }

    public displayModal(event){
       if(event["action"] == "close"){
         this.showModal = false;
       }else{
         this.showModal = true;
       }
    }

    private sendToApp(id: string){
      this.servicesService.sendToApp(id).subscribe(result => {
          //console.log(result);
      });
    }

    private removeFromApp(id: string){
      this.servicesService.removeFromApp(id).subscribe(result => {
        //console.log(result);
      });
    }

    private sendToAppWithPro(id: string, idPro: string) {
      this.servicesService.sendToAppWithProf(id, idPro).subscribe(result => {});
    }

    private getResumeComments(object: object){
      this.servicesService.getCommentsResume(object["id_service"].toString()).subscribe(result => {
        this.commentsResume["commentData"] = result;
        this.commentsResume["serviceData"] = object;
        this.commentsResume["serviceData"]["with_products"] = (object["with_products"] == 1) ? "con productos" : "sin productos"; 
        if(object["periodicity"] == 'none') this.commentsResume["serviceData"]["periodicity_text"] =  "puntual";
        if(object["periodicity"] == '1-week') this.commentsResume["serviceData"]["periodicity_text"] =  "semanal";
        if(object["periodicity"] == '2-week') this.commentsResume["serviceData"]["periodicity_text"] =  "quincenal";
        this.displayModal("open");
      });
    }

    ngOnInit(){
      this.getAssignServices();
    }
    
}


// WEBPACK FOOTER //
// ./src/app/modules/assign/components/main-assign.component.ts